import { render, staticRenderFns } from "./photoGallery.vue?vue&type=template&id=4e41652d&scoped=true"
import script from "./photoGallery.vue?vue&type=script&lang=js"
export * from "./photoGallery.vue?vue&type=script&lang=js"
import style0 from "./photoGallery.vue?vue&type=style&index=0&id=4e41652d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41652d",
  null
  
)

export default component.exports